import { Updater, AsyncState, HttpResult, loadedAsyncState, loadingAsyncState } from "widgets-for-react";
import { FormResponse, MailPlusClient } from "../../backendApi/generated";

const mailplusClient = new MailPlusClient(window.location.origin)

export interface MailPlusFormState {
  formId: string
  result: AsyncState<FormResponse>
}

export const initialMailPlusFormState: (formId: string) => MailPlusFormState =
(formId) => {
  return {
    formId,
    result: loadingAsyncState(() => getMailPlusForm(formId))
  };
}

export const mailPlusFormPageStateUpdaters = {
  updateSearchResult: (updater: Updater<AsyncState<FormResponse>>) =>
    (state: MailPlusFormState): MailPlusFormState => ({
      ...state,
      result: updater(state.result),
    }),
}

export const getMailPlusForm = async (formId: string): Promise<HttpResult<FormResponse>> => {
  const res = await mailplusClient.getForm(formId);
  return {
    kind: 'result',
    status: 200,
    value: res,
  }
}

const brochureIDs: number[] = [1152, 1153, 1154, 1155, 1156, 1157, 1158, 1159, 1160, 1161, 1190, 1162, 1191, 1756, 10166, 10260, 11455]
export const isBrochureForm = (formId: number): boolean => {
  return brochureIDs.includes(formId);
}
const adviseIDs: number[] = [10956]
export const isAdviseForm = (formId: number): boolean => {
  return adviseIDs.includes(formId);
}
const optInIDs: number[] = [2555, 11313, 10957]
export const isOptInForm = (formId: number): boolean => {
  return optInIDs.includes(formId);
}
